import React, { useEffect, useState } from "react";
import { ApiGetAllPeriodos } from "../../../api/periodos";
import CrearDiaInactivo from "../../../components/admin/diasInactivos/diasInactivos";
import ListadoDiasInactivos from "../../../components/admin/diasInactivos/listadoDiasInactivos";

const initialState = {
  pre_periodo_id: "",
  fecha: "",
};

const DiasInactivos = () => {
  const [updateList, setUpdateList] = useState(false);
  const [type, setType] = useState("save");
  const [state, setState] = useState(initialState);
  const [listadoPeriodos, setListadoPeriodos] = useState([]);

  useEffect(() => {
    const fetchPeriodos = async () => {
      const response = await ApiGetAllPeriodos();
      if (response.sms === "ok") {
        const periodosActivos = response.data.filter(
          (periodo) => periodo.estado === true
        );
        setListadoPeriodos(periodosActivos);
      } else {
        console.log(response);
      }
    };

    fetchPeriodos();
  }, [updateList]);

  const updateListFn = () => {
    setUpdateList(!updateList);
  };

  const resetState = () => {
    setState(initialState);
  };

  return (
    <div className="h-100 px-3 bgfondo2 d-flex justify-content-start flex-column ">
      <CrearDiaInactivo
        updateListFn={updateListFn}
        state={state}
        setState={setState}
        type={type}
        setType={setType}
        resetState={resetState}
        listadoPeriodos={listadoPeriodos}
      />
      <ListadoDiasInactivos
        updateList={updateList}
        updateListFn={updateListFn}
        setState={setState}
        setType={setType}
        listadoPeriodos={listadoPeriodos}
      />
    </div>
  );
};

export default DiasInactivos;